module.exports = __webpack_public_path__ + "static/media/OVER.be288824.png";